import { PropsButton } from './PropsButton';
import classNames from 'classnames';

import styles from './Button.module.scss';

export const Button = ({ children, className, themes, fullWith, arrow = 'none', icon, ...props }: PropsButton): JSX.Element => {
  return (
    <button
      className={classNames(
        styles.Button,
        !themes && styles.Default,
        themes === 'red' && styles.Red,
        themes === 'purple' && styles.Purple,
        themes === 'white' && styles.White,
        themes === 'outlineRed' && styles.OutlineRed,
        themes === 'outlinePurple' && styles.OutlinePurple,
        themes === 'success' && styles.Success,
        props.disabled && styles.Disabled,
        fullWith && styles.fullWith,
        className,
      )}
      {...props}
    >
      {children}
      {arrow !== 'none' && icon && (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={icon} alt={'Иконка кнопки'} className={classNames(styles.Icon)} />
      )}
    </button>
  );
};
